import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Lightbulb, MessageCircle, Loader2 } from "lucide-react";
import { api } from "../lib/api";

export const AssignmentSpark = ({ assignment }) => {
  const [spark, setSpark] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    api.post(`/assignments/${assignment.id}/spark`)
      .then((r) => setSpark(r.data))
      .catch(() => setSpark(null))
      .finally(() => setLoading(false));
  }, [assignment.id]);

  if (loading) {
    return (
      <div className="flex items-center gap-2 p-3 bg-[#FFE066]/40 border-2 border-black rounded-xl text-sm" data-testid={`spark-loading-${assignment.id}`}>
        <Loader2 size={16} className="animate-spin" /> Mia's thinking of a spark...
      </div>
    );
  }
  if (!spark) {
    return <p className="text-xs text-gray-500 p-2" data-testid={`spark-error-${assignment.id}`}>Couldn't load a spark — tap again later.</p>;
  }

  return (
    <div className="space-y-2" data-testid={`spark-${assignment.id}`}>
      <div className="flex gap-2 p-3 bg-[#FFE066] border-2 border-black rounded-xl text-sm shadow-[2px_2px_0px_rgba(0,0,0,1)]">
        <Lightbulb size={16} className="shrink-0 mt-0.5" />
        <p className="font-medium">{spark.idea}</p>
      </div>
      <div className="flex gap-2 p-3 bg-[#F2C6DE] border-2 border-black rounded-xl text-sm shadow-[2px_2px_0px_rgba(0,0,0,1)]">
        <MessageCircle size={16} className="shrink-0 mt-0.5" />
        <p><span className="font-bold">Mia asks:</span> {spark.question}</p>
      </div>
      <button
        onClick={() =>
          navigate("/chat", {
            state: {
              prefill: `Let's work on my ${assignment.subject} ${assignment.type} "${assignment.title}". You asked: "${spark.question}" — help me think it through.`,
            },
          })
        }
        data-testid={`spark-chat-button-${assignment.id}`}
        className="w-full bg-[#4D96FF] border-2 border-black rounded-full shadow-[3px_3px_0px_rgba(0,0,0,1)] active:shadow-none active:translate-y-[2px] transition-all font-bold py-2 text-sm flex items-center justify-center gap-2"
      >
        <MessageCircle size={15} /> Answer Mia in chat
      </button>
    </div>
  );
};
